import React, { Component } from 'react'

import T from '../../translate/T'

import AspectRatio from '../../atoms/AspectRatio'
import Icon from '../../atoms/Icon'
import FontIcon from '../../atoms/FontIcon'
import Font from '../../atoms/Font'
import Valign from '../../atoms/Valign'
import BoxShadow from '../../atoms/BoxShadow'

import { date } from '../../../helpers/Formatter'
import { Config } from '../../_config'
import style from './style.css'

export default class BoxEvent extends Component {

    componentWillMount() {
        this.data = this.props.data
    }

    render() {
        return (
            <BoxShadow className={style.box}>
                { (this.data.cover && (
                    <AspectRatio image={`${Config.imgEvent}${this.data.cover}`} ratio='3x1' />
                ))}

                <div className={style.container}>
                    <div className={style.barLeft}>
                        <div className={style.iconTop}>
                            {this.props.type === 'trainning' ? (
                                <FontIcon name='trainning' />
                            ) : (
                                <FontIcon name='star' />
                            )}

                        </div>
                        <div className={style.textV}>
                            {this.props.type === 'trainning' ? T.text('trainning') : T.text('event')}
                        </div>
                        <div className={style.actionIcon} style={{display: 'none'}}>
                            <Icon name='bell' />
                        </div>
                    </div>

                    <div className={style.content}>
                        <div className={style.date}>
                            <Font size='15' color='#999999' style={{position: 'relative', right: '4px'}}>{date(this.data.date).month('br').abbrev.toUpperCase()}</Font>
                            <br />
                            <Font size='50' color='#999999' style={{position: 'relative', top: '-8px'}}>{date(this.data.date).day(true)}</Font>
                        </div>
                        <div className={style.title}>
                            <Font weight='bold' color='#545454' size='16'>
                                {this.data.title}
                            </Font>
                        </div>
                        <div className={style.location}>
                            <Valign>
                                <span  style={{
                                    color: '#ff5500',
                                    fontSize: '12px',
                                    marginRight: '10px'
                                }} >
                                    <FontIcon name='pin'/>
                                </span>
                                <Font size='14' color='#545454' className={style.city}>
                                {this.data.city} {this.data.state_abbreviation && `(${this.data.state_abbreviation})`}
                                {this.data.location || ''}
                                </Font>
                            </Valign>
                        </div>
                    </div>
                </div>
            </BoxShadow>
        )
    }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/molecules/BoxEvent/index.js